import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { Target } from '../../TargetsContext/types'
import { Permission } from '@cims-online/shared'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateLimsAsphaltMixDesignTargetMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useTargetsContext } from '../../TargetsContext'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<Target> {
  const { projectId } = useProjectContext()
  const { refetch } = useTargetsContext()
  const [create] = useCreateLimsAsphaltMixDesignTargetMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createLIMSAsphaltMixDesignTarget: {
        target: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    entity: 'Target',
    permission: Permission.CreateLIMSAsphaltMixDesignTarget,
    modal: {
      type: 'simple',
      onOk: async ({
        percentages,
        required,
        ...values
      }: CreateEditFormItemsValues & {
        required: boolean
        percentages?: {
          mixDesignId: string
          name: string
          percentage: number
        }[]
      }) => {
        await create({
          variables: {
            input: {
              ...values,
              projectId,
              optional: !required,
              percentages: percentages?.map(({ mixDesignId, percentage }) => ({
                // Required field so using bang
                percentage: percentage!,
                mixDesignId,
              })),
            },
          },
        })
        refetch()
      },
      body: <CreateEditFormItems showRequired />,
    },
  }
}
